// Sinkronkan favicon & ikon shortcut (Add to Dock / Add to Home Screen)
// dengan logo yang diupload di menu Pengaturan.
const ICON_RELS = ['icon', 'apple-touch-icon', 'apple-touch-icon-precomposed'];

const setLink = (rel, href, attrs = {}) => {
  let el = document.querySelector(`link[rel="${rel}"]${attrs.sizes ? `[sizes="${attrs.sizes}"]` : ''}`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  el.setAttribute('href', href);
};

export const applyAppIcons = (logoVersion) => {
  // Tanpa logo: hapus semua ikon supaya favicon kosong
  if (!logoVersion) {
    document.querySelectorAll(ICON_RELS.map((r) => `link[rel="${r}"]`).join(',')).forEach((el) => el.remove());
  } else {
    const v = encodeURIComponent(logoVersion);
    setLink('icon', `/api/settings/icon/favicon.ico?v=${v}`, { sizes: 'any' });
    setLink('icon', `/api/settings/icon/icon-32.png?v=${v}`, { type: 'image/png', sizes: '32x32' });
    setLink('icon', `/api/settings/icon/icon-192.png?v=${v}`, { type: 'image/png', sizes: '192x192' });
    setLink('apple-touch-icon', `/api/settings/icon/icon-180.png?v=${v}`, { sizes: '180x180' });
    setLink('apple-touch-icon-precomposed', `/api/settings/icon/icon-180.png?v=${v}`, { sizes: '180x180' });
  }

  // Manifest dinamis (dipakai Chrome) ikut di-versi agar tidak memakai cache lama
  setLink('manifest', `/api/settings/manifest.json${logoVersion ? `?v=${encodeURIComponent(logoVersion)}` : ''}`);
};
